import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
  justify-content: center;
  width: 660px;

  @media (max-width: 768px) {
    width: calc(100% - 20px);
    margin: 6px 10px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  border: 0px solid ${({ theme }) => theme.colors.GREY_HEAVY};
  border-radius: 12px;
  min-height: 131px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  width: 100%;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.BLACK};
  padding: 50px 0 0 10px;
  font-weight: bold;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 6px;
`;

export const CardsWrapper = styled.div`
    overflow: hidden;
    transition: height 0.3s ease-out, opacity 0.3s ease-out;
    height: 0;
    opacity: 0;

    &.expanded {
        height: auto;
        opacity: 1;
        transition: height 1s ease-in, opacity 1s ease-in;
    }
`;

